import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import ActionButton from "../components/ActionButton";
import FormHelperText from "@material-ui/core/FormHelperText";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TaxonomySelector from "../components/taxonomy/TaxonomySelector";
import { taxServiceClient } from "../AxiosClient";
import { withTranslation, Trans } from "react-i18next";

const styles = (theme) => ({
  paper: {
    minWidth: 1100,
    maxWidth: 1500,
  },
});

export class AddTeamDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    userState: {},
    teamNameError: true,
    saving: false,
  };

  render() {
    const { classes, t } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <Trans i18nKey="create_new_team" />
        </DialogTitle>
        <DialogContent>
          <TextField
            error={this.state.teamNameError}
            fullWidth
            style={{ marginBottom: 10 }}
            onChange={this.validateTeamName}
            value={this.state.teamName}
            label={t("global_team")}
            helperText={
              this.state.teamNameError ? (
                <Trans i18nKey="enter_team_name" />
              ) : null
            }
            id="team-name"
          />
          <TaxonomySelector
            multiSelect
            onNodeSelected={(e) => this.setState({ selectedNode: e })}
            allowedSelections={["taxonomy"]}
            filter={
              this.state.selectedNode
                ? this.state.selectedNode.length
                  ? this.state.selectedNode
                  : [this.state.selectedNode]
                : []
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color="primary">
            <Trans i18nKey="global_cancel" />
          </Button>
          <ActionButton
            loading={this.state.saving}
            disabled={this.state.teamNameError}
            onClick={this.saveTeam}
            color="primary"
            id="save-team"
          >
            <Trans i18nKey="global_save" />
          </ActionButton>
        </DialogActions>
      </Dialog>
    );
  }
  saveTeam = () => {
    this.setState({ saving: true });
    let attachedTaxonomyNodes = null;

    if (this.state.selectedNode != null) {
      attachedTaxonomyNodes = this.state.selectedNode.filter((x) => {
        if (x.type === "taxonomy") {
          return true;
        } else {
          return false;
        }
      });
      attachedTaxonomyNodes = attachedTaxonomyNodes.map((x) => {
        return x.id;
      });
    }

    !this.state.teamNameError &&
      taxServiceClient
        .post(`/team/`, {
          teamName: this.state.teamName,
          attachedNodes: attachedTaxonomyNodes,
        })
        .then((res) => {
          this.setState({ saving: false });
          this.props.addTeam(res.data);
          attachedTaxonomyNodes &&
            attachedTaxonomyNodes.forEach((node) => {
              taxServiceClient.post(`/taxonomy/${node}/team/`, {
                teamId: res.data.teamId,
                taxonomyId: node,
              });
            });
        });
  };
  stateUpdated = (state) => {
    this.setState({ userState: state });
  };

  validateTeamName = (e) => {
    e.target.value === ""
      ? this.setState({ teamNameError: true, teamName: e.target.value })
      : this.setState({ teamNameError: false, teamName: e.target.value });
  };
}

export default withStyles(styles)(withTranslation()(AddTeamDialog));
